import { ADMIN_MESSAGE_FORMATS } from '../../../../constants/messageFormats';

const STANDARD_SENDER_FORMATS = new Set([
  ADMIN_MESSAGE_FORMATS.TEXT,
  ADMIN_MESSAGE_FORMATS.IMAGE,
  ADMIN_MESSAGE_FORMATS.FILE,
]);

const normalizeValue = (value) => String(value == null ? '' : value).trim().toLowerCase();

const hasAdminSenderIdentity = (row) =>
  Boolean(
    row?.admin_user_id ||
      row?.sender_admin_user_id ||
      row?.admin_full_name ||
      row?.admin_display_name ||
      row?.admin_username ||
      row?.admin_name
  );

export const shouldShowAdminSenderForMessage = (message) => {
  const row = message || {};
  const messageType = normalizeValue(row.message_type);
  const senderType = normalizeValue(row.sender_type);
  const messageFormat = normalizeValue(row.message_format);
  const isAdminSender =
    messageType === 'admin_message' || senderType === 'admin' || hasAdminSenderIdentity(row);
  if (messageType === 'system_message' || !isAdminSender || !messageFormat) return false;
  return STANDARD_SENDER_FORMATS.has(messageFormat) && hasAdminSenderIdentity(row);
};

export const shouldExcludeAdminSenderForMessage = (message) => {
  const row = message || {};
  const messageType = normalizeValue(row.message_type);
  const messageFormat = normalizeValue(row.message_format);

  if (shouldShowAdminSenderForMessage(row)) return false;
  if (messageType === 'system_message') return true;
  if (!messageFormat) return false;
  return !STANDARD_SENDER_FORMATS.has(messageFormat);
};
